<template>
  <div class="workbench">
    <loading :isShow="loading" />
    <!-- 左边 -->
    <div class="quest">
      <div v-if="numObj.policySettleableTotall || (numObj.withdrawRejectCount > 0 && !($units.isOkBao() || $units.isOkTX()))" class="tips-wrap swiper">
        <!-- 驳回提示 -->
        <div class="swiper-wrapper">
          <div class="tips swiper-slide" v-if="numObj.withdrawRejectCount > 0 && !$units.isOkBao()">
            <img src="../../static/images/workbench/tip.png" />
            <div class="tip-message">
              您有<span class="num">{{ numObj.withdrawRejectCount }}</span
              >笔个险平台提现被驳回
            </div>
            <div class="look" @click="jumpPage('/settlementManage/financialRecord', { tabId:'2', status: '2' })">
              请查看<i class="iconfont iconchakangengduojiantou fontjiantou"></i>
            </div>
          </div>
          <!-- 结算提醒 -->
          <div class="tips swiper-slide" v-if="numObj.policySettleableTotall">
            <img src="../../static/images/workbench/tip.png" />
            <div class="tip-message">
              截至今日0时，下一结算周期可结算平台保单<span class="num">{{ numObj.policySettleableTotall.policyNum }}</span
              >件，预估服务费<span class="num">{{ numObj.policySettleableTotall.incomesSum }}</span
              >元；不可结算保单<span class="num">{{ numObj.policySettleableTotall.unsettleablePolicyNum }}</span
              >件。
            </div>
            <div class="look" @click="$router.push({ path: '/settlementManage/settleablePolicy' })">
              请查看<i class="iconfont iconchakangengduojiantou fontjiantou"></i>
            </div>
          </div>
        </div>
      </div>
      <!-- 审批任务 -->
      <div class="task" v-if="userInfo.levelCode == '10001'">
        <div class="task-title">
          <span class="tips1"></span>
          审批任务
        </div>
        <div class="task-tips">
          <div
            class="task-item"
            @click="goRouter('org_2125_0', '/orgManage/inductionAudit', { isVisitor: '0', auditStatus: '6' })"
            v-if="numObj.entryAuditCount > 0"
          >
            <img src="../../static/images/workbench/task1.png" />
            <div>
              <div class="num1">{{ numObj.entryAuditCount }}</div>
              <div>入职信息待审核</div>
            </div>
          </div>
          <div class="task-item" v-else>
            <img src="../../static/images/workbench/task1.png" />
            <div>
              <div class="num">0</div>
              <div>入职信息待审核</div>
            </div>
          </div>
          <div
            class="task-item"
            @click="goRouter('org_2125_0', '/orgManage/inductionAudit', { isVisitor: '0', auditStatus: '5' })"
            v-if="numObj.entryContractSignedCount > 0"
          >
            <img src="../../static/images/workbench/task2.png" />
            <div>
              <div class="num2">{{ numObj.entryContractSignedCount }}</div>
              <div>入职合同待签署</div>
            </div>
          </div>
          <div class="task-item" v-else>
            <img src="../../static/images/workbench/task2.png" />
            <div>
              <div class="num">0</div>
              <div>入职合同待签署</div>
            </div>
          </div>
          <div
            class="task-item"
            @click="goRouter('org_2125_0', '/orgManage/inductionAudit', { isVisitor: '0', auditStatus: '1' })"
            v-if="numObj.entryContractAuditCount > 0"
          >
            <img src="../../static/images/workbench/task3.png" />
            <div>
              <div class="num3">{{ numObj.entryContractAuditCount }}</div>
              <div>入职合同待审核</div>
            </div>
          </div>
          <div class="task-item" v-else>
            <img src="../../static/images/workbench/task3.png" />
            <div>
              <div class="num">0</div>
              <div>入职合同待审核</div>
            </div>
          </div>
          <div class="task-item" @click="goRouter('offline_81_6_0', '/financialManage/salesmanWithdrawal', {})" v-if="numObj.userWithdrawAuditCount > 0">
            <img src="../../static/images/workbench/task4.png" />
            <div>
              <div class="num4">{{ numObj.userWithdrawAuditCount }}</div>
              <div v-if="!($units.isOkBao() || $units.isOkTX())">业务员提现待审核</div>
              <div v-else>业务员提现待打款</div>
            </div>
          </div>
          <div class="task-item" v-else>
            <img src="../../static/images/workbench/task4.png" />
            <div>
              <div class="num">0</div>
              <div v-if="!($units.isOkBao() || $units.isOkTX())">业务员提现待审核</div>
              <div v-else>业务员提现待打款</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 异常人力 待续期协议-->
      <div class="two-task" v-if="userInfo.levelCode == '10001'">
        <div class="task">
          <div class="task-title">
            <span class="tips1"></span>
            异常人力
          </div>
          <div class="task-tips">
            <div
              class="task-item"
              @click="goRouter('org_2_0', '/orgManage/salesmanManage', { workingState: '1', qualificationFlag: '0' })"
              v-if="numObj.joinedNotCertifiedCount > 0"
            >
              <div class="num5">{{ numObj.joinedNotCertifiedCount }}</div>
              <div>已入职未认证</div>
            </div>
            <div class="task-item" v-else>
              <div class="num">0</div>
              <div>已入职未认证</div>
            </div>
            <div class="task-item" @click="goRouter('org_2_0', '/orgManage/salesmanManage', { workingState: '999' })" v-if="numObj.suspensionCount > 0">
              <div class="num5">{{ numObj.suspensionCount }}</div>
              <div>停职人力</div>
            </div>
            <div class="task-item" v-else>
              <div class="num">0</div>
              <div>停职人力</div>
            </div>
            <div
              class="task-item"
              @click="goRouter('org_2_0', '/orgManage/salesmanManage', { workingState: '0', qualificationFlag: '1' })"
              v-if="numObj.departNotOfflineCount > 0"
            >
              <div class="num5">{{ numObj.departNotOfflineCount }}</div>
              <div>已离职未下号</div>
            </div>
            <div class="task-item" v-else>
              <div class="num">0</div>
              <div>已离职未下号</div>
            </div>
          </div>
        </div>
        <div class="task">
          <div class="task-title">
            <span class="tips1"></span>
            待续期协议
          </div>
          <div class="task-tips">
            <!-- 保司：comAgreementWillExpireCount；通道：chaAgreementWillExpireCount； -->
            <div class="task-item" @click="goDetailAgreement('1')" v-if="numObj.chaAgreementWillExpireCount + numObj.comAgreementWillExpireCount > 0">
              <div class="num6">{{ numObj.chaAgreementWillExpireCount + numObj.comAgreementWillExpireCount }}</div>
              <div>
                上游协议即将到期<Tooltip max-width="100px" content="30天内即将到期的主协议">
                  <i class="iconfont iconwenhao-xin" style="color: #a8adb7; margin-left: 2px; font-size: 14px"></i>
                </Tooltip>
              </div>
            </div>
            <div class="task-item" v-else>
              <div class="num">0</div>
              <div>
                上游协议即将到期<Tooltip max-width="100px" content="30天内即将到期的主协议">
                  <i class="iconfont iconwenhao-xin" style="color: #a8adb7; margin-left: 2px"></i>
                </Tooltip>
              </div>
            </div>
            <!-- 保司：comAgreementExpireCount；通道：chaAgreementExpireCount； -->
            <div class="task-item" @click="goDetailAgreement('2')" v-if="numObj.comAgreementExpireCount + numObj.chaAgreementExpireCount > 0">
              <div class="num6">{{ numObj.comAgreementExpireCount + numObj.chaAgreementExpireCount }}</div>
              <div>上游协议已到期</div>
            </div>
            <div class="task-item" v-else>
              <div class="num">0</div>
              <div>上游协议已到期</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 待提交/待支付订单提醒 -->
      <div class="allOrderTips" v-if="orderTab != '0'">
        <div class="topTips">
          <div class="title">
            <span class="tips1"></span>
            <span>待提交/待支付订单提醒</span>
          </div>
          <div class="topBtns">
            <div class="btns">
              <span class="orderBtn" :class="{ active: orderTab == '1' }" @click="clickTab('1')">个险订单</span>
              <span class="orderBtn" :class="{ active: orderTab == '2' }" @click="clickTab('2')">团财投保单</span>
              <span class="orderBtn" :class="{ active: orderTab == '3' }" @click="clickTab('3')">团财保全单</span>
            </div>
            <span class="more" @click="moreOrder">更多<i class="iconfont iconchakangengduojiantou fontjiantou"></i></span>
          </div>
        </div>
        <div v-if="orderTab == '1'">
          <order v-if="$units.pointAction('order_10_0')"></order>
          <noLimits v-else></noLimits>
        </div>
        <div v-if="orderTab == '2'">
          <groupOrder v-if="$units.pointAction('order_40_1_0')"></groupOrder>
          <noLimits v-else></noLimits>
        </div>
        <div v-if="orderTab == '3'">
          <peservation v-if="$units.pointAction('order_40_2_0')"></peservation>
          <noLimits v-else></noLimits>
        </div>
      </div>
      <!-- 异常数据监测 -->
      <div class="abnormalData">
        <div class="topTips">
          <div class="title"><span class="tips1"></span>异常数据监测</div>
        </div>
        <div class="content">
          <div class="tab">
            <div class="btns">
              <span class="abnormalBtn" :class="{ active: abnormalTab == '7' }" @click="clickAbnormalTab('7')"
                >未回执回访保单<span class="tipNums" v-if="abnormalData.noReceiptRevisitPolicyCount > 0">{{
                  getNumber(abnormalData.noReceiptRevisitPolicyCount)
                }}</span></span
              >
              <span class="abnormalBtn" :class="{ active: abnormalTab == '8' }" @click="clickAbnormalTab('8')" v-if="userInfo.levelCode == '10001'"
                >未质检保单<span class="tipNums" v-if="abnormalData.unqualifiedPolicyCount > 0">{{
                  getNumber(abnormalData.unqualifiedPolicyCount)
                }}</span></span
              >
              <span class="abnormalBtn" :class="{ active: abnormalTab == '1' || abnormalTab == '0' }" @click="clickAbnormalTab('1')" v-if="!keys2"
                >无费率的产品<span class="tipNums" v-if="abnormalData.noCommissionProductCount > 0">{{
                  getNumber(abnormalData.noCommissionProductCount)
                }}</span></span
              >
              <span class="abnormalBtn" :class="{ active: abnormalTab == '2' }" @click="clickAbnormalTab('2')" v-if="!keys"
                >机构未配费的产品<span class="tipNums" v-if="abnormalData.orgNoCommissionProductCount > 0">{{
                  getNumber(abnormalData.orgNoCommissionProductCount)
                }}</span></span
              >
              <span class="abnormalBtn" :class="{ active: abnormalTab == '3' }" @click="clickAbnormalTab('3')" v-if="!keys1"
                >团队未配费的产品<span class="tipNums" v-if="abnormalData.groupNoCommissionProductCount > 0">{{
                  getNumber(abnormalData.groupNoCommissionProductCount)
                }}</span></span
              >
              <span class="abnormalBtn" :class="{ active: abnormalTab == '4' || abnormalTab == '5' }" @click="clickTwoTab()"
                >模板中未配费的产品<span
                  class="tipNums"
                  v-if="abnormalData.orgTemNoCommissionProductCount > 0 || abnormalData.groupTemNoCommissionProductCount > 0"
                  >{{ getNumber(Number(abnormalData.orgTemNoCommissionProductCount) + Number(abnormalData.groupTemNoCommissionProductCount)) }}</span
                ></span
              >
              <!-- <span class="abnormalBtn" :class="{active:abnormalTab=='4'}" @click="clickAbnormalTab('4')">机构模板</span>
              <span class="abnormalBtn" :class="{active:abnormalTab=='5'}" @click="clickAbnormalTab('5')">团队模板</span> -->
              <span class="abnormalBtn" :class="{ active: abnormalTab == '6' }" @click="clickAbnormalTab('6')"
                >未匹配到费用的保单<span class="tipNums" v-if="abnormalData.noCommissionPolicyCount > 0">{{
                  getNumber(abnormalData.noCommissionPolicyCount)
                }}</span></span
              >
              <span class="abnormalBtn" :class="{ active: abnormalTab == '9' }" @click="clickAbnormalTab('9')"
                >录入异常单<span class="tipNums" v-if="abnormalData.abnormalPolicyCount > 0">{{ getNumber(abnormalData.abnormalPolicyCount) }}</span></span
              >
            </div>
            <span
              class="more"
              @click="moreAbnormal"
              v-if="abnormalTab == '0' || abnormalTab == '1' || abnormalTab == '7' || abnormalTab == '8' || abnormalTab == '9'"
              >更多<i class="iconfont iconchakangengduojiantou fontjiantou"></i
            ></span>
          </div>
          <Tabs v-model="noPolicyStatus" class="second-tabs" :animated="false" v-if="abnormalTab == '4' || abnormalTab == '5'" @on-click="changeSecondTabs">
            <TabPane label="机构模板" name="4"></TabPane>
            <TabPane label="团队模板" name="5"></TabPane>
          </Tabs>
          <div v-if="abnormalTab == '0' || abnormalTab == '1'">
            <noRateProduct v-if="$units.pointAction('pro_2_0') && userInfo.levelCode == '10001'"></noRateProduct>
            <noRateProduct2 v-else-if="$units.pointAction('commission_10_0') && userInfo.levelCode != '10001'"></noRateProduct2>
            <noLimits v-else></noLimits>
          </div>
          <div v-if="abnormalTab == '2'">
            <institutionalProduct v-if="$units.pointAction('commission_10_0')"></institutionalProduct>
            <noLimits v-else></noLimits>
          </div>
          <div v-if="abnormalTab == '3'">
            <institutionalGroupProduct v-if="$units.pointAction('commission_10_0')"></institutionalGroupProduct>
            <noLimits v-else></noLimits>
          </div>
          <div v-if="abnormalTab == '4'">
            <mechanismTemplate v-if="$units.pointAction('commission_20_0')"></mechanismTemplate>
            <noLimits v-else></noLimits>
          </div>
          <div v-if="abnormalTab == '5'">
            <teamTemplate v-if="$units.pointAction('commission_20_0')"></teamTemplate>
            <noLimits v-else></noLimits>
          </div>
          <div v-if="abnormalTab == '6'">
            <noMatchingCommission
              v-if="$units.pointAction('order_30_0') || $units.pointAction('order_50_0') || $units.pointAction('order_40_2_0')"
              @getTab="getAnormalNum"
            ></noMatchingCommission>
            <noLimits v-else></noLimits>
          </div>
          <div v-if="abnormalTab == '7'">
            <noReturnPolicy v-if="$units.pointAction('order_1_40_0')"></noReturnPolicy>
            <noLimits v-else></noLimits>
          </div>
          <div v-if="abnormalTab == '8'">
            <uninspectedPolicy v-if="$units.pointAction('order_1_61_0')"></uninspectedPolicy>
            <noLimits v-else></noLimits>
          </div>
          <div v-if="abnormalTab == '9'">
            <anomalyOrder v-if="$units.pointAction('order_30_0')" @getTab="getAnormalNum"></anomalyOrder>
            <noLimits v-else></noLimits>
          </div>
        </div>
      </div>
    </div>
    <!-- 右边 -->
    <div class="message">
      <div class="userInfo">
        <div class="userImage">
          <img src="../../static/images/workbench/woman.png" alt="" v-if="userInfo.sex == '2'" />
          <img src="../../static/images/workbench/man.png" alt="" v-else-if="userInfo.sex == '1'" />
          <img src="../../static/images/workbench/sex.png" alt="" v-else />
          <div class="userName">{{ userInfo.userName }}，你好！</div>
        </div>
        <div class="userMessage">
          <div style="margin-bottom: 6px">今天是{{ new Date() | filterTime('YYYY年MM月DD日') }}，{{ nowWeek }}</div>
          <div>
            您的角色是<span style="color: #236dff; font-weight: 800">{{ userInfo.roleName }}</span
            >，所属机构为<span style="color: #236dff; font-weight: 800">{{ userInfo.organizationName }}</span>
          </div>
        </div>
      </div>
      <div
        class="platformAnnouncement"
        v-if="($units.pointAction('operate_9_0') && userInfo.levelCode == '10001') || (userInfo.levelCode != '10001' && platformAnnouncementList.length > 0)"
      >
        <div class="title">
          <span class="name"><span class="tips1"></span>平台公告</span>
          <span class="more" @click="$router.push({ path: '/home/chatMange', query: {} })"
            >更多<i class="iconfont iconchakangengduojiantou fontjiantou"></i
          ></span>
        </div>
        <div class="content" v-if="platformAnnouncementList.length > 0">
          <div class="item" v-for="(item, index) in platformAnnouncementList.slice(0, 5)" :key="index" @click="goNoticeDetail(item)">
            <div class="item-title"><i class="redDian" v-if="!item.hasReaded"></i>{{ item.title }}</div>
            <div class="time">
              {{ item.sendTime | filterTime('YYYY-MM-DD') }}
            </div>
          </div>
        </div>
        <noData v-else></noData>
      </div>
      <div class="myAnnouncement" v-if="userInfo.levelCode == '10001' || (userInfo.levelCode != '10001' && myAnnouncementList.length > 0)">
        <div class="title">
          <span class="name"><span class="tips1"></span>我的公告</span>
          <span class="more" @click="$router.push({ path: '/operate/noticeManage', query: {} })"
            >更多<i class="iconfont iconchakangengduojiantou fontjiantou"></i
          ></span>
        </div>
        <div class="content" v-if="myAnnouncementList.length > 0">
          <div class="item" v-for="(item, index) in myAnnouncementList.slice(0, 5)" :key="index" @click="goNoticeDetail(item)">
            <div class="item-title">{{ item.title }}</div>
            <div class="time">
              {{ item.sendTime | filterTime('YYYY-MM-DD') }}
            </div>
          </div>
        </div>
        <noData v-else></noData>
      </div>
      <div class="helpCenter">
        <div class="title">
          <div class="titleName">
            <span class="tips1"></span>
            <span>帮助中心</span>
          </div>

          <a class="more" :href="'https://lazhukeji.yuque.com/ugxyxw/mpgzy4?#'" target="_blank"
            >更多<i class="iconfont iconchakangengduojiantou fontjiantou"></i
          ></a>
        </div>
        <a class="content" :href="'https://lazhukeji.yuque.com/ugxyxw/mpgzy4?#'" target="_blank">
          <div class="h">关于本系统</div>
          <div class="li">· 系统简介</div>
          <div class="li">· 如有问题如何联系我们？</div>
          <div class="h">电脑管理端操作手册</div>
          <div class="li">· 组织管理-新增机构</div>
          <div class="li">· 组织管理-新增团队</div>
          <div class="li">· 业务员管理-新增单个业务员</div>
          <div class="li">· 业务员管理-批量新增业务员</div>
          <div class="li">· 业务员管理—修改密码、晋升、降级、迁移、离职、复职</div>
          <div class="li">· 业务员管理—上游工号维护</div>
          <div class="li">· 维护业务员职级范围</div>
        </a>
      </div>
    </div>
    <div class="notice-box">
      <Modal
        v-if="numObj.policyConfirmRightTotal && showPolicyConfirmRightTotal"
        :transfer="false"
        title="单录待处理通知"
        v-model="showPolicyConfirmRightTotal"
        footer-hide
        width="340px"
        class="noticeModel"
        :mask="false"
      >
        <div class="notice-wrap">
          截至{{ numObj.policyConfirmRightTotal.statisticsDate | filterTime('MM月DD日') }}0时，待处理的单录<span
            class="num"
            @click="
              $router.push({
                path: '/orderManage/qualityTesting',
                query: {
                  confirmRightStatusIn: ['0', '-1']
                }
              })
            "
            >保单{{ numObj.policyConfirmRightTotal.policyNum }}件</span
          >，预估服务费{{ numObj.policyConfirmRightTotal.incomesSum }}元。
        </div>
      </Modal>
      <Modal title="回执回访通知" :transfer="false" v-model="receiptRevisitModal" footer-hide width="340px" class="noticeModel" :mask="false">
        您当前有回执回访的保单待处理：
        <div class="footer-Btn">
          <span @click="clickReturnBtn('2')" style="color: #f47900; cursor: pointer">待回执({{ totalReturnData.waitReceiptCounts || 0 }})</span>
          <span type="primary" @click="clickReturnBtn('3')" style="color: #f47900; cursor: pointer">待回访（{{ totalReturnData.waitVisitCounts || 0 }}）</span>
        </div>
      </Modal>
    </div>
  </div>
</template>
                                                                                           
<script>
import dayjs from 'dayjs';
import { common } from '@/api/mixins';
import order from './components/order';
import groupOrder from './components/groupOrder';
import peservation from './components/peservation';
import noRateProduct from './components/noRateProduct';
import noRateProduct2 from './components/noRateProduct2';
import institutionalProduct from './components/institutionalProduct';
import institutionalGroupProduct from './components/institutionalGroupProduct';
import mechanismTemplate from './components/mechanismTemplate';
import teamTemplate from './components/teamTemplate';
import noReturnPolicy from './components/noReturnPolicy';
import uninspectedPolicy from './components/uninspectedPolicy';
import anomalyOrder from './components/anomalyOrder';
import noMatchingCommission from './components/noMatchingCommission';
import noLimits from '@/components/commons/noLimits';
import { chatMangeList } from '@/api/httpList';
import Swiper from '@static/js/swiper-4.3.3.min';
import '@static/css/swiper-4.3.3.min.css';
export default {
  mixins: [common],
  components: {
    order,
    groupOrder,
    peservation,
    noRateProduct,
    noRateProduct2,
    institutionalProduct,
    institutionalGroupProduct,
    mechanismTemplate,
    teamTemplate,
    noReturnPolicy,
    uninspectedPolicy,
    anomalyOrder,
    noMatchingCommission,
    noLimits
  },
  data() {
    return {
      loading: false,
      receiptRevisitModal: false,
      totalReturnData: {},
      numObj: {},
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      returnDate: JSON.parse(localStorage.getItem('returnDate')),
      nowWeek: '',
      platformAnnouncementList: [],
      myAnnouncementList: [],
      orderTab: '',
      noPolicyStatus: '4',
      abnormalTab: '1',
      returnStatistics: false,
      showPolicyConfirmRightTotal: true,
      abnormalData: {},
      mySwiper: {},
      keys: false,
      keys1: false,
      keys2: false
    };
  },
  mounted() {
    this.getAnormalTab();
  },
  activated() {
    //根据存储时间判断是否展示回访数据
    this.returnDate = JSON.parse(localStorage.getItem('returnDate'));
    if (this.returnDate) {
      if (this.$units.formatDate(new Date()) == this.$units.formatDate(this.returnDate)) {
        this.returnStatistics = true;
      } else {
        this.returnStatistics = false;
      }
    } else {
      this.returnStatistics = false;
    }

    //根据存储时间判断是否展示回访数据
    let date = JSON.parse(localStorage.getItem('policyConfirmRightTotal'));
    if (date && this.$units.formatDate(new Date()) == this.$units.formatDate(date)) {
      this.showPolicyConfirmRightTotal = false;
    } else {
      this.showPolicyConfirmRightTotal = true;
    }

    this.getReturnTotal();
    this.getDate();
    this.init();
  },
  methods: {
    jumpPage(url, query) {
      sessionStorage.query = JSON.stringify(query);
      this.$router.push(url);
    },
    initSwiper() {
      if(this.mySwiper && this.mySwiper.destroy){
        this.mySwiper.destroy();
      }
      let dom = document.querySelectorAll('.swiper-slide');
      console.log('dom',dom)
      this.mySwiper  = new Swiper('.tips-wrap', {
        autoplay: dom.length > 1,
        loop:dom.length > 1,
        delay:5000,
        direction: 'vertical' // 水平切换选项
      });
    },
    getKeys() {
      let keys, keys1, keys2, keysArr, keysArr1, keysArr2;
      this.$http({
        url: '/system/sysParams/getValue',
        type: 'GET',
        data: {
          key: 'not_display_orgNoCommissionProduct_tenantid'
        }
      }).then(res => {
        keys = res.data;
        if (keys && keys.includes(',')) {
          keysArr = keys.split(',');
          this.keys = keysArr.includes(this.userInfo.tenantId);
        } else {
          this.keys = keys.includes(this.userInfo.tenantId);
        }
      });
      this.$http({
        url: '/system/sysParams/getValue',
        type: 'GET',
        data: {
          key: 'not_display_groupNoCommissionProduct_tenantid'
        }
      }).then(res => {
        keys1 = res.data;
        if (keys1 && keys1.includes(',')) {
          keysArr1 = keys1.split(',');
          this.keys1 = keysArr1.includes(this.userInfo.tenantId);
        } else {
          this.keys1 = keys1.includes(this.userInfo.tenantId);
        }
      });
      this.$http({
        url: '/system/sysParams/getValue',
        type: 'GET',
        data: {
          key: 'not_display_noCommissionProduct_tenantid'
        }
      }).then(res => {
        keys2 = res.data;
        if (keys2 && keys2.includes(',')) {
          keysArr2 = keys2.split(',');
          this.keys2 = keysArr2.includes(this.userInfo.tenantId);
        } else {
          this.keys2 = keys2.includes(this.userInfo.tenantId);
        }
      });
    },
    clickReturnBtn(val) {
      this.receiptRevisitModal = false;
      this.$nextTick(() => {
        this.$router.push({ path: '/orderManage/visitReceived/visitReceived', query: { secondTab: val } });
      });
    },
    // 未回执回访统计
    getReturnTotal() {
      this.$http({
        url: '/buz/policyReceiptRecord/policyReceipt/noticeData',
        type: 'get',
        params: {}
      }).then(res => {
        if (res.data) {
          this.totalReturnData = res.data;
        } else {
          this.totalReturnData = {
            waitReceiptCounts: 0,
            waitVisitCounts: 0
          };
        }
        if (!this.returnStatistics && (this.totalReturnData.waitReceiptCounts || this.totalReturnData.waitVisitCounts)) {
          localStorage.setItem('returnDate', new Date().getTime());
          this.receiptRevisitModal = true;
        }
      });
    },
    getNumber(val) {
      if (val) {
        if (Number(val) > 100) {
          return '99+';
        } else {
          return val;
        }
      }
    },
    goRouter(code, path, query) {
      if (!this.$units.pointAction(code)) {
        this.$notice.error('无对应菜单权限，无法跳转');
        return;
      }
      this.$router.push({ path: path, query: query });
    },
    moreAbnormal() {
      if (this.abnormalTab == '1' || this.abnormalTab == '0') {
        if (this.userInfo.levelCode == '10001') {
          if (!this.$units.pointAction('pro_2_0')) {
            this.$notice.error('无对应菜单权限，无法跳转');
            return;
          }
          this.$router.push({ path: '/productResource/productManager', query: { isThereRate: '0', publishStatus: '', salesStatus: '' } });
        } else {
          if (!this.$units.pointAction('commission_10_0')) {
            this.$notice.error('无对应菜单权限，无法跳转');
            return;
          }
          this.$router.push({ path: '/productResource/fee', query: { isThereRate: '0' } });
        }
      } else if (this.abnormalTab == '7') {
        if (!this.$units.pointAction('order_1_40_0')) {
          this.$notice.error('无对应菜单权限，无法跳转');
          return;
        }
        this.$router.push({ path: '/orderManage/visitReceived/visitReceived', query: { receiptStatusList: ['0', '2'], revisitStatusList: ['0', '2'] } });
      } else if (this.abnormalTab == '8') {
        if (!this.$units.pointAction('order_1_61_0')) {
          this.$notice.error('无对应菜单权限，无法跳转');
          return;
        }
        this.$router.push({ path: '/orderManage/qualityTesting', query: { confirmRightStatusIn: ['0', '1', '-1'] } });
      } else if (this.abnormalTab == '9') {
        if (!this.$units.pointAction('order_30_0')) {
          this.$notice.error('无对应菜单权限，无法跳转');
          return;
        }
        this.$router.push({ path: '/orderManage/insuredOrder/main', query: { isAbnormal: '1' } });
      }
    },
    moreOrder() {
      if (this.orderTab == '1') {
        if (!this.$units.pointAction('order_10_0')) {
          this.$notice.error('无对应菜单权限，无法跳转');
          return;
        }
        this.$router.push({ path: '/orderManage', query: { status: '1' } });
      } else if (this.orderTab == '2') {
        if (!this.$units.pointAction('order_40_1_0')) {
          this.$notice.error('无对应菜单权限，无法跳转');
          return;
        }
        this.$router.push({ path: '/orderManage/group/order', query: { checkInsuranceStatusList: ['0', '1'] } });
      } else if (this.orderTab == '3') {
        if (!this.$units.pointAction('order_40_2_0')) {
          this.$notice.error('无对应菜单权限，无法跳转');
          return;
        }
        this.$router.push({ path: '/orderManage/group/peservation', query: { statusList: ['0', '20'] } });
      }
    },
    changeSecondTabs() {
      this.abnormalTab = this.noPolicyStatus;
    },
    clickTwoTab() {
      this.abnormalTab = 4;
    },
    clickAbnormalTab(val) {
      if (val == this.abnormalTab) {
        return;
      } else {
        this.abnormalTab = val;
      }
    },
    clickTab(val) {
      if (val == this.orderTab) {
        return;
      } else {
        this.orderTab = val;
      }
    },
    goNoticeDetail(item) {
      window.open('/home/detail?id=' + item.id);
      // 修改读取状态
      this.$http({
        type: 'get',
        url: '/buz/noticeConfig/read/msg',
        data: {
          id: item.id
        }
      }).then(() => {
        window.parent.postMessage(
          {
            reloadReadNum: true,
            appMessage: true
          },
          '*'
        );
        chatMangeList({ pageNo: 1, pageSize: 5, source: '2' }).then(res => {
          this.platformAnnouncementList = res.data;
        });
        chatMangeList({ pageNo: 1, pageSize: 5 }).then(res => {
          this.myAnnouncementList = res.data;
        });
      });
    },
    goDetailAgreement(val) {
      if (!this.$units.pointAction('pro_6_0')) {
        this.$notice.error('无对应菜单权限，无法跳转');
        return;
      }
      if (val == '1') {
        if (this.numObj.comAgreementWillExpireCount > 0) {
          this.$router.push({
            path: '/offline/agreementManage/supplierAgreement',
            query: { tab: 'insuranceCompany', date: '30', status: '1', covenantLevel: '1', time: new Date() }
          });
        } else if (this.numObj.chaAgreementWillExpireCount > 0) {
          this.$router.push({
            path: '/offline/agreementManage/supplierAgreement',
            query: { tab: 'channel', date: '30', status: '1', covenantLevel: '1', time: new Date() }
          });
        }
      } else if (val == '2') {
        if (this.numObj.comAgreementExpireCount > 0) {
          this.$router.push({
            path: '/offline/agreementManage/supplierAgreement',
            query: { tab: 'insuranceCompany', status: '2', covenantLevel: '1', time: new Date() }
          });
        } else if (this.numObj.chaAgreementExpireCount > 0) {
          this.$router.push({
            path: '/offline/agreementManage/supplierAgreement',
            query: { tab: 'channel', status: '2', covenantLevel: '1', time: new Date() }
          });
        }
      }
    },
    getAnormalTab() {
      this.$http({
        type: 'get',
        url: '/buz/workBenches/getAbnormalTab',
        data: {}
      }).then(res => {
        this.abnormalTab = res.data.tabCode;
        if (this.abnormalTab == '4' || this.abnormalTab == '5') {
          this.noPolicyStatus = this.abnormalTab;
        }
      });
    },
    getAnormalNum() {
      this.$http({
        type: 'get',
        url: '/buz/workBenches/getAbnormalCount',
        data: {}
      }).then(res => {
        this.abnormalData = res.data;
      });
    },
    getOrderTab() {
      this.$http({
        type: 'get',
        url: '/buz/workBenches/getOrderTab',
        data: {}
      }).then(res => {
        this.orderTab = res.data;
      });
    },
    getDate() {
      const weeks = new Array('星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六');
      this.nowWeek = weeks[new Date().getDay()];
    },
    async init() {
      this.loading = true;
      const res = await this.$http({
        url: '/buz/workBenches/statistics',
        type: 'GET',
        data: {}
      });
      chatMangeList({ pageNo: 1, pageSize: 5, source: '2' }).then(res => {
        this.platformAnnouncementList = res.data;
      });
      chatMangeList({ pageNo: 1, pageSize: 5 }).then(res => {
        this.myAnnouncementList = res.data;
      });
      this.getOrderTab();
      this.getKeys();
      this.getAnormalNum();
      this.loading = false;
      this.numObj = res.data;

      if (this.showPolicyConfirmRightTotal && this.numObj.policyConfirmRightTotal) {
        localStorage.setItem('policyConfirmRightTotal', new Date().getTime());
        this.showPolicyConfirmRightTotal = true;
      }
      setTimeout(() => {
        this.initSwiper();
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
@import './workbench.scss';
</style>